import { useState } from 'react'
import { Send, CheckCircle } from 'lucide-react'
import { subscribeToMailerLite, MAILERLITE_INTENTS } from '@/lib/mailerlite'

export default function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [succeeded, setSucceeded] = useState(false)
  const [error, setError] = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    setSubmitting(true)
    setError(null)

    try {
      await subscribeToMailerLite(email.trim(), '', MAILERLITE_INTENTS.NEWSLETTER)
      setSucceeded(true)
      setEmail('')
    } catch (err) {
      setError(err?.message || 'Something went wrong. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  if (succeeded) {
    return (
      <div className={`flex items-center gap-2 ${compact ? '' : 'justify-center'}`}>
        <CheckCircle className="w-4 h-4 text-[var(--gold)]" aria-hidden="true" />
        <span className="text-[var(--text-muted)] text-sm">You're subscribed!</span>
      </div>
    )
  }

  return (
    <div className={compact ? 'w-full' : 'w-full md:w-auto'}>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          aria-label="Email address"
          placeholder="email@example.com"
          className="w-full sm:flex-1 sm:min-w-0 px-4 py-3 rounded-xl bg-[var(--bg-surface)] border border-[var(--outline-ghost)] text-[var(--text-primary)] placeholder:text-[var(--text-muted-placeholder)] text-sm focus:outline-none focus:ring-2 focus:ring-[var(--gold)]/50"
        />
        <button
          type="submit"
          disabled={submitting}
          className="w-full sm:w-auto bg-[var(--gold)] text-[var(--text-on-gold)] font-semibold px-6 py-3 rounded-xl hover:brightness-110 transition-all text-sm flex items-center justify-center gap-2 whitespace-nowrap disabled:opacity-50"
        >
          {submitting ? (
            'Subscribing...'
          ) : (
            <>
              Subscribe <Send className="w-3.5 h-3.5" aria-hidden="true" />
            </>
          )}
        </button>
      </form>
      {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
    </div>
  )
}
